import { getTitleThemeColor } from '../../../templates.js';
import { bodyMixin } from './bodyMixin.js';

/** 带标题的正文卡片共用逻辑 */
export const bodyCardMixin = {
	mixins: [bodyMixin],
	computed: {
		themeColor() {
			return getTitleThemeColor(this.data);
		},
	},
	methods: {
		onTitleUpdate(title) {
			this.$emit('update', { title });
		},
	},
};
